import React from 'react'
import { styled } from '@mui/material/styles'

export const ErrorMessage = styled('p')(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '0.7rem',
    lineHeight: '16px',
    color: theme.palette.error.main,
    marginBottom: '0px',
}))